import { createGlobalStyle } from 'styled-components';

import TTNormsProWoff from './tt-norms-pro-regular.woff';
import TTNormsProWoff2 from './tt-norms-pro-regular.woff2';

import TTNormsProThinWoff from './tt-norms-pro-thin.woff';
import TTNormsProThinWoff2 from './tt-norms-pro-thin.woff2';

import TTNormsProBoldWoff from './tt-norms-pro-bold.woff';
import TTNormsProBoldWoff2 from './tt-norms-pro-bold.woff2';

export default createGlobalStyle`
    @font-face {
        font-family: 'TTNorms';
        src: local('TTNorms'), local('TTNorms'),
        url(${TTNormsProWoff2}) format('woff2'),
        url(${TTNormsProWoff}) format('woff');
        font-weight: 500;
        font-style: normal;
    }
    @font-face {
        font-family: 'TTNorms';
        src: local('TTNorms'), local('TTNorms'),
        url(${TTNormsProThinWoff2}) format('woff2'),
        url(${TTNormsProThinWoff}) format('woff');
        font-weight: 100;
        font-style: thin;
    }
    @font-face {
        font-family: 'TTNorms';
        src: local('TTNorms'), local('TTNorms'),
        url(${TTNormsProBoldWoff2}) format('woff2'),
        url(${TTNormsProBoldWoff}) format('woff');
        font-weight: 600;
        font-style: bold;
    }
`;